var React = require('react');

function Time (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM5.5,1.2C6.2,0.6,7,0.3,8,0.3c0.9,0,1.7,0.3,2.4,0.8","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8.3","r":"7.4","key":1}),React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t8,4.3 8,8.3 10.8,11.1 \t","key":2})]));
}

Time.displayName = "Time";

Time.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Time;

Time.default = Time;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/time.svg
// module id = ../icon/src/icons/time.svg
// module chunks = 0